import { getPaymentAttempt } from './checkout-attempts'
import { captureRumError, isRumActive, trackRumAction } from './rum.helper'
import { TELEMETRY_EVENT_NAMES } from './telemetry-events.constants'

import type { UnifiedPaymentGateway } from './track-unified-checkout-events'

export const PDP_EXPRESS_RUM_MODULE = 'PDP_EXPRESS'

export const PDP_EXPRESS_APPLE_PAY = 'apple_pay'

export const PDP_EXPRESS_ACTIONS = {
  PAY_BUTTON_CLICKED: TELEMETRY_EVENT_NAMES.PDP_EXPRESS_PAY_BUTTON_CLICKED,
  SHIPPING_UPDATED: TELEMETRY_EVENT_NAMES.PDP_EXPRESS_SHIPPING_UPDATED,
  PAYMENT_INITIATED: TELEMETRY_EVENT_NAMES.PDP_EXPRESS_PAYMENT_INITIATED,
  PAYMENT_AUTHORISED: TELEMETRY_EVENT_NAMES.PDP_EXPRESS_PAYMENT_AUTHORISED,
} as const

export const PDP_EXPRESS_STEPS = {
  SESSION_CREATION: 'session_creation',
  MERCHANT_VALIDATION: 'merchant_validation',
  CHECKOUT_CREATION: 'checkout_creation',
  SHIPPING_CONTACT_UPDATE: 'shipping_contact_update',
  SHIPPING_METHOD_UPDATE: 'shipping_method_update',
  SHIPPING_BLOCKED_AUTHORIZATION: 'shipping_blocked_authorization',
  PAYMENT_AUTHORIZATION: 'payment_authorization',
  SESSION_BEGIN: 'session_begin',
  CLICK: 'click',
} as const

export const PDP_EXPRESS_SHIPPING_UPDATE_TYPES = {
  CONTACT: 'contact',
  METHOD: 'method',
} as const

export type PdpExpressRumContext = Record<string, unknown>

const getPaymentInitToken = (): string | undefined => {
  if (!isRumActive()) return undefined
  try {
    return getPaymentAttempt()?.token
  } catch {
    return undefined
  }
}

export const trackPdpExpressAction = (
  action: string,
  paymentMethod: string,
  paymentGateway: UnifiedPaymentGateway,
  context: PdpExpressRumContext = {},
): void => {
  trackRumAction(action, {
    payment_method: paymentMethod,
    payment_gateway: paymentGateway,
    payment_init_token: getPaymentInitToken(),
    ...context,
  })
}

export const capturePdpExpressError = (
  error: unknown,
  step: string,
  paymentMethod: string,
  paymentGateway: UnifiedPaymentGateway,
  context: PdpExpressRumContext = {},
): void => {
  captureRumError(error, {
    module: PDP_EXPRESS_RUM_MODULE,
    step,
    payment_method: paymentMethod,
    payment_gateway: paymentGateway,
    payment_init_token: getPaymentInitToken(),
    ...context,
  })
}
